module.exports = "/images/pin-performance-active.png?8738ef4caecc83e825926a3fd28645a1";